<template>
	<!--
    The formatting of this template is intential, removes unwanted spaces
    between inline & inline-block elements. Don't like it? Use word wrap.
  -->
	<component
		:is="tag"
		v-on="$listeners"
		class="cta-v2"
		:class="[left ? 'left' : right ? 'right' : '']"
		tabindex="0"
		:type="tag === 'button' ? 'button' : null"
		><Icon v-if="left" type="left" /><slot
			v-if="left"
			name="icon"
		/><slot /><slot name="after-text" /><slot v-if="right" name="icon" /><Icon
			v-if="right"
			type="right"
		/>
	</component>
</template>

<script>
import { Icon } from "../icon";

/**
 * This component makes a CTA using either an anchor, button or span tag.
 */
export default {
	name: "CTA",

	components: {
		Icon
	},

	props: {
		/**
		 * Set the element tag.
		 *
		 * @values button, a, span
		 */
		tag: {
			type: String,
			default: "button",
			validator: (value) => {
				return ["button", "a", "span"].includes(value);
			}
		},

		/**
		 * Set to `true` for a left arrow.
		 */
		left: {
			type: Boolean,
			default: false
		},

		/**
		 * Set to `true` for a right arrow.
		 */
		right: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.cta-v2 {
	color: $color--red;
	font-family: inherit;
	font-size: 14px;
	font-weight: $font-weight--bold;
	line-height: 1;
	text-decoration: none;
	background-color: transparent;
	border: 0;
	cursor: pointer;
	transition: 0.2s ease text-decoration;

	@include hover {
		color: $color--dark-red;
		text-decoration: underline;
	}

	.icon {
		display: inline-block;
		font-size: 12px;
		line-height: 1;
		vertical-align: middle;
		transition: 0.2s ease transform;

		&.icon-left {
			margin: 0 4px 0 0;
		}

		&.icon-right {
			margin: 0 0 0 4px;
		}
	}

	&:hover,
	&:focus {
		.icon-left {
			transform: translateX(-4px);
		}

		.icon-right {
			transform: translateX(4px);
		}
	}

	&.left * {
		margin: 0 4px 0 0;
	}
	&.right * {
		margin: 0 0 0 4px;
	}
}
</style>
